// extracted by mini-css-extract-plugin
module.exports = {"hub-switch":"hub-switch_hub-switch__5l2n3"};